import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/support.png';
const _hoisted_1 = {
  width: "100%",
  height: "100%"
};
const _hoisted_2 = {
  x: "50%",
  y: "50%",
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  fill: "url(#text-gradient)",
  "font-size": "48px",
  "font-family": "YouSheBiaoTiHei"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", {
    class: "app-header",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(0))
  }, [(_openBlock(), _createElementBlock("svg", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("defs", null, [_createElementVNode("linearGradient", {
    id: "text-gradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, [_createElementVNode("stop", {
    offset: "0%",
    "stop-color": "#F1FEFF"
  }), _createElementVNode("stop", {
    offset: "100%",
    "stop-color": "#87FBFF"
  })])], -1)), _createElementVNode("text", _hoisted_2, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])])), _cache[2] || (_cache[2] = _createElementVNode("img", {
    class: "support",
    src: _imports_0,
    alt: "技术支持: 中瑞鑫安 云媒科技"
  }, null, -1))]);
}